import React from 'react'

const SportsLoader = () => {
  return (
    <div className="loading_spinner"></div>
  );
};

export default SportsLoader;
